export const GOOGLE_MAP_API_KEY = 'AIzaSyDlBMF-g4blFQw2zr3bnOZD5V5CcnRORqg';

export const reactRouterBaseRoute = '/v2';

export const ENABLE_CAPTCHA = true;
export const ENABLE_HELP_EDIT = false;